import axios from 'axios';
import * as JSPM from 'jsprintmanager';
import {webusbPrinter} from './webusb-printer';

// Server assignment selects the printer. Browser storage holds USB permission only.
export async function prepareLocalPrinter(printer, pair=false) {
  if(Number(printer.connection_type)===3){
    if(JSPM.JSPrintManager.websocket_status!==JSPM.WSStatus.Open)throw new Error('Open JSPrintManager on the assigned Windows terminal.');
    return;
  }
  if(Number(printer.connection_type)!==4)throw new Error('This is not a local check printer.');
  const key=`ordering-usb:${printer.id}`;
  if(pair){await webusbPrinter.disconnect();const device=await webusbPrinter.pair();if(!device.serial)throw new Error('This printer has no USB serial. Confirm supported hardware before using automatic printing.');localStorage.setItem(key,device.serial);}
  else {const serial=localStorage.getItem(key);if(!serial)throw new Error('Use Test Print to pair this assigned printer. A stable USB serial is required.');if(webusbPrinter.connectedSerial()!==serial){await webusbPrinter.disconnect();await webusbPrinter.silentConnect(serial);}}
  if(!webusbPrinter.isConnected())throw new Error('Pair the check printer once using Test Print on its assigned tablet.');
}
export async function writeLocalPrint(data) {
  const bytes=Uint8Array.from(atob(data.bytes),c=>c.charCodeAt(0));
  if(Number(data.printer.connection_type)===4){await webusbPrinter.printKitchenBytes(bytes);return;}
  const job=new JSPM.ClientPrintJob();
  job.clientPrinter=new JSPM.InstalledPrinter(data.printer.os_printer_name);
  job.printerCommands=Array.from(bytes).map(c=>String.fromCharCode(c)).join('');
  await job.sendToClient();
}
export async function dispatchLocalTicket(job) {
  await prepareLocalPrinter(job.snapshot.printer);
  const attempt=crypto.randomUUID();let claimed=false;
  try {
    const {data}=await axios.post(`/kitchen/printing/tickets/${job.id}/send`,{attempt_id:attempt});claimed=true;
    await writeLocalPrint(data);
    await axios.post(`/kitchen/printing/tickets/${job.id}/result`,{attempt_id:attempt,state:'sent'});
  } catch(e) {
    if(claimed)try{await axios.post(`/kitchen/printing/tickets/${job.id}/result`,{attempt_id:attempt,state:'unknown'});}catch(_){}
    throw e;
  }
}
